import { render, staticRenderFns } from "./cannyCourse.vue?vue&type=template&id=3536e91c&scoped=true"
import script from "./cannyCourse.vue?vue&type=script&lang=js"
export * from "./cannyCourse.vue?vue&type=script&lang=js"
import style0 from "./cannyCourse.vue?vue&type=style&index=0&id=3536e91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536e91c",
  null
  
)

export default component.exports